const CustomSkeleton = ({ className = '' }: { className: string }) => {
	return (
		<div className={`${className} bg-slate-200 dark:bg-slate-700 rounded animate-pulse`}>
		</div>
	)
}

export const PostSkeleton = () => {
	return (
		<div className="flex flex-row-reverse justify-between sm:justify-start sm:flex-col">
			<CustomSkeleton className="sm:h-48 w-32 h-32 sm:w-full" />
			<div className="w-full mr-6">
				<CustomSkeleton className="sm:w-32 h-3 my-3 inline-block mr-2 w-full" />
				<CustomSkeleton className=" h-4 mb-4 w-full" />
				<CustomSkeleton className=" h-4 mb-4 w-full" />
				{/* <CustomSkeleton className="h-2 my-3" /> */}
				<CustomSkeleton className="h-2 my-3 w-full" />
				<div className="space-x-4 my-4 hidden sm:flex">
					<CustomSkeleton className="h-10 w-10 rounded-full" />
					<div>
						<CustomSkeleton className="h-2 my-2 w-20" />
						<CustomSkeleton className="h-2 my-2 w-24" />
					</div>
				</div>
			</div>
		</div>
	)
}

export const ItemSkeleton = () => {
	return (
		<div className="flex flex-row-reverse justify-between sm:justify-start sm:flex-col">
			<CustomSkeleton className="sm:h-48 w-32 h-32 sm:w-full" />
			<div className="w-full mr-6">
				<CustomSkeleton className="sm:w-32 h-3 my-3 inline-block mr-2 w-full" />
				<CustomSkeleton className=" h-4 mb-4 w-full" />
				<CustomSkeleton className=" h-4 mb-4 w-full" />
			</div>
		</div>
	)
}
export default CustomSkeleton